var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875391 11.4281C0.725391 11.2781 0.650391 11.1031 0.650391 10.9031C0.650391 10.7031 0.725391 10.5281 0.875391 10.3781L4.95039 6.30312L0.875391 2.22813C0.725391 2.07813 0.650391 1.90312 0.650391 1.70312C0.650391 1.50313 0.725391 1.32812 0.875391 1.17812C1.02539 1.02812 1.20039 0.953125 1.40039 0.953125C1.60039 0.953125 1.77539 1.02812 1.92539 1.17812L6.42539 5.67812C6.50872 5.76146 6.57139 5.85712 6.61339 5.96512C6.65472 6.07379 6.67539 6.18646 6.67539 6.30312C6.67539 6.41979 6.65472 6.53212 6.61339 6.64012C6.57139 6.74879 6.50872 6.84479 6.42539 6.92812L1.92539 11.4281C1.77539 11.5781 1.60039 11.6531 1.40039 11.6531C1.20039 11.6531 1.02539 11.5781 0.875391 11.4281Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRightArrow);
export default __webpack_public_path__ + "static/media/pagination-right-arrow.50726d09fd9e63c2cc30e97e8978d2a2.svg";
export { ForwardRef as ReactComponent };